import isFeatureEnabled from '../../is-feature-enabled';
import AssetPickerTypes from '../asset-picker-types';
import AssetPickerEditOption from './asset-picker-edit-option';

function AssetPickerEditAssetOptions({ assetType, renameCallback, deleteCallback, hideEditButton = false }) {
  const showEditOption =
    !(isFeatureEnabled('draft_and_publish_guides') && assetType === AssetPickerTypes.GUIDE) && !hideEditButton;

  return (
    <div className="asset-picker-edit-options asset-picker-edit-asset-options">
      {showEditOption && (
        <div className="asset-picker-edit-option">
          <AssetPickerEditOption
            title={`Edit the name of this ${assetType}`}
            src="/images/edit_icon_blue.svg"
            height="75%"
            onClick={renameCallback}
          />
        </div>
      )}
      <div className="asset-picker-edit-option">
        <AssetPickerEditOption
          title={`Delete this ${assetType}`}
          src="/images/cross_icon_blue.svg"
          height="68%"
          onClick={deleteCallback}
        />
      </div>
    </div>
  );
}

export default AssetPickerEditAssetOptions;
